import { useEffect, useState } from 'react';
import { Input, Message, Space, Typography } from '@arco-design/web-react';
import FormModal from '../../../components/FormModal';
import { createBlacklist } from '../../../api/blacklists';
import { maskPhone } from '../../../utils/format';

/** 通话结束后「加入黑名单」弹窗：号码预填，备注自由 */
export default function BlacklistModal(props: { visible: boolean; number: string; onClose: () => void }) {
  const { visible, number, onClose } = props;
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (visible) setReason('');
  }, [visible]);
  const submit = async () => {
    if (!number) {
      Message.warning('无可封禁号码');
      return;
    }
    setSaving(true);
    try {
      await createBlacklist({ number, reason: reason.trim() || undefined, enabled: true });
      Message.success(`已加入黑名单：${maskPhone(number)}`);
      onClose();
    } catch {
      /* 拦截器已提示（/blacklists 写端已对所有登录角色开放，仍以接口返回为准） */
    } finally {
      setSaving(false);
    }
  };
  /* 加入黑名单（操作录入表单，表单档 560；danger 语义确定按钮） */
  return (
    <FormModal
      title="加入黑名单"
      visible={visible}
      onCancel={onClose}
      onOk={submit}
      okText="确认加入"
      cancelText="取消"
      confirmLoading={saving}
      status="danger"
    >
      <Space direction="vertical" size={8} style={{ width: '100%' }}>
        <Typography.Text type="secondary">号码</Typography.Text>
        <Input value={maskPhone(number)} readOnly />
        <Typography.Text type="secondary">备注（可选）</Typography.Text>
        <Input value={reason} onChange={setReason} placeholder="如：骚扰电话 / 客户要求不再联系" maxLength={200} />
      </Space>
    </FormModal>
  );
}
